<template>
  <div id="organization">
    <div class="organization-list">
      <div class="organization-item" v-for="(v, i) in list" :key="i">
        <div class="organization-img">
          <img class="bg-img" :src="v.imgUrl" alt="" @error="imgError('/img/user.png')">
        </div>
        <div class="organization-content hidden-xs-only">
          <h2 class="txt-line-1">
            {{v.title}}/<span class="subTitle">{{v.subTitle}}</span>
          </h2>
          <p class="txt-line-6 text-indent">{{v.described}}</p>
        </div>
        <div class="organization-content-xs">
          <h2 class="txt-line-2">
            {{v.title}}/<span>{{v.subTitle}}</span>
          </h2>
          <p class="txt-line-6">{{v.described}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {imgError} from '@/assets/utility.js'
export default {
  data() {
    return {
      content: '',
      list: [],
      currentPage: 1,
      pageSize: 50,
      total: 0
    }
  },
  mounted() {
    this.$store.commit('setAboutTabI', 2)
    this.loadData()
  },
  methods: {
    imgError(pUrl) {
      imgError(pUrl)
    },
    handleCurrentChange(e) {
      this.currentPage = e
      this.loadData()
    },
    loadData () {
      this.$axios.post('about/getCouncilList').then((res)=>{
        if (res) {
          this.list = res.rows
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
 .organization-list {
    .organization-item {
      .organization-content {
        flex: 1;
        p {
          font-weight: 400;
          color: #999999;
          text-indent: rem(40);
        }
      }
    }
  }

  @media only screen and (min-width: 768px) {
    .organization-list {
      padding: rem(50) 0;
      .organization-item {
        display: flex;
        padding: rem(50) 0 rem(50) 0;
        border-top: 1px solid #bfbfbf;
        // background-color: #fff;
        .organization-img {
          width: rem(652);
          height: rem(430);
          //border-radius: rem(48);
          overflow: hidden;
          .img-content {
            width: 100%;
            height: 100%;
          }
        }
        .organization-content {
          position: relative;
          padding-left: rem(60);
          h2 {
            font-size: rem(48);
            .subTitle {
              font-size: rem(24)
            }
          }
          p {
            margin-top: rem(48);
            margin-bottom: rem(110);
            font-size: rem(20);
            line-height: rem(40);
          }
        }
        .organization-content-xs {
          display: none;
        }
      }
    }
  }
  @media only screen and (max-width: 768px) {
    .organization-list {
      padding: .575rem;
      .organization-item {
        padding-bottom: 1rem;
        position: relative;
        .organization-img {
          width: 100%;
          height: 2.9rem;
          //border-radius: .25rem;
          overflow: hidden;
          .img-content {
            width: 100%;
            height: 100%;
          }
        }
        .organization-content-xs {
          h2 {
            font-size: 0.5rem;
            font-weight: 500;
            color: #333333;
            position:absolute;
            left:50%;
            top:1.6rem;
            transform: translate(-50%);
            color:#fff;
            span {
              font-size: .25rem;
            }
          }
          p {
              padding-top: .5rem;
              margin: 0;
              font-size: 0.31rem;
              font-weight: 400;
              color: #606060;
              line-height: 0.5rem;
            }
        }
      }
    }
  }
</style>